import React from "react";
import { Box } from "@mui/material";
import CommentCard from "./CommentCard";

export default function CommentThread() {
  return (
    <Box>
      <Box sx={styles.headingWrapper}>
        <Box as="h2" sx={styles.headingText}>
          Comments
          <Box as="span" sx={{ color: "#98a29a", ml: 1 }}>
            180
          </Box>
        </Box>
        <Box
          as="p"
          sx={{
            color: "#c0392b",
            fontFamily: "FustatSemiBold",
            fontSize: "13px",
            m: 0,
          }}
        >
          3 needs moderation
        </Box>
      </Box>

      <CommentCard />
    </Box>
  );
}

const styles = {
  headingWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 3,
    mb: 2,
  },
  headingText: {
    m: 0,
    fontFamily: "FustatBold",
    fontSize: "19px",
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    color: "#0C2728",
  },
};
